import styles from './SubmitButton.module.scss';

import cx from 'classnames';
import { SUBMIT_BUTTON_TEST_ID } from './Submitbutton.const';

// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import React from 'react';
import { SproutButton } from 'components/Button/SproutButton';

type ISubmitButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  disabled?: boolean;
};

export const SubmitButton: React.FunctionComponent<ISubmitButtonProps> = ({
  children,
  className,
  ...props
}) => (
  <SproutButton
    type="submit"
    data-testid={SUBMIT_BUTTON_TEST_ID.submitButton}
    className={cx(styles.submitButton, className, {
      [styles.submitButtonDisabled]: props.disabled,
    })}
    variant="primary"
    {...props}
  >
    {children}
  </SproutButton>
);
